import { render, staticRenderFns } from "./orderSummaries.vue?vue&type=template&id=402d7569&scoped=true&"
import script from "./orderSummaries.vue?vue&type=script&lang=js&"
export * from "./orderSummaries.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402d7569",
  null
  
)

export default component.exports